export default __webpack_public_path__ + "static/GraphikSemibold-7ef1e78abcb43e957eec8e9ac2479d1f.otf";